module.exports = __webpack_public_path__ + "img/toutu_renliziyuan@1x.ccb53bfe.png";